import { render } from "./WarningInfo.vue?vue&type=template&id=79b13f2d&scoped=true"
import script from "./WarningInfo.vue?vue&type=script&lang=js"
export * from "./WarningInfo.vue?vue&type=script&lang=js"

import "./WarningInfo.vue?vue&type=style&index=0&id=79b13f2d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b13f2d"]])

export default __exports__